import React, { Component } from 'react';
import { toast } from 'react-toastify';
import './NewsItem.scss';
import Icon from '../../components/Icon/Icon';
import ICONS from '../../components/Icon/IconPaths';

class NewsItem extends Component {

  constructor(props) {
    super(props);
    this.state = { isYesToggleOn: false };
    this.state = { isNoToggleOn: false };

    // This binding is necessary to make `this` work in the callback
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleNoClick = this.handleNoClick.bind(this);
    this.handleYesToast = this.handleYesToast.bind(this);
    this.handleNoToast = this.handleNoToast.bind(this);
  }

  handleYesToast() {
    toast("Preferences updated!");
  }

  handleNoToast() {
    toast("Preferences updated!");
  }

  handleYesClick() {
    this.setState(state => ({
      isYesToggleOn: !state.isYesToggleOn,
      isNoToggleOn: false
    }));
    this.handleYesToast();
  }

  handleNoClick() {
    this.setState(state => ({
      isNoToggleOn: !state.isNoToggleOn,
      isYesToggleOn: false
    }));
    this.handleNoToast();
  }

  render() {
    return (
      <div className="news-item">
        {this.props.children}
        <div className="personalisation d-flex justify-content-around justify-content-lg-end">
          <button className="btn --icon mr-2" onClick={this.handleLink}>
            <Icon icon={ICONS.LINK} className="Icon --Personalisation" />
            <div className="tooltip --bottom-right"><p className="caption m-0">Link</p></div>
          </button>
          <button className="btn --icon mx-2" onClick={this.handleYesClick}>
            <Icon icon={this.state.isYesToggleOn ? ICONS.INTERESTED_SOLID : ICONS.INTERESTED} className={this.state.isYesToggleOn ? "Icon --Personalisation active" : "Icon --Personalisation"} />
            <div className="tooltip --bottom-right"><p className="caption m-0">Interested</p></div>
          </button>
          <button className="btn --icon ml-2" onClick={this.handleNoClick}>
            <Icon icon={this.state.isNoToggleOn ? ICONS.NOT_INTERESTED_SOLID : ICONS.NOT_INTERESTED} className={this.state.isNoToggleOn ? "Icon --Personalisation active" : "Icon --Personalisation"} />
            <div className="tooltip --bottom-right"><p className="caption m-0">Not interested</p></div>
          </button>
        </div>
      </div>
    );
  }
}

export default NewsItem;